import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Link2 = createReactComponent("Link2", ["svg", defaultAttributes, [["path", {
  d: "M15 7h2a5 5 0 010 10h-2m-6 0H7A5 5 0 017 7h2",
  key: "2adp1c"
}], ["line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12",
  key: "6hnc9b"
}]]]);
export default Link2;